import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import { IComplementItem } from '../models';

class ComplementItemsService {
  private httpClient = HttpClient;

  public async listComplementItems(
    companyId: number,
    complementId: number,
  ): Promise<IComplementItem[]> {
    try {
      const complementItems = await this.httpClient.get(
        `/companies/${companyId}/complements/${complementId}/items`,
      );

      return complementItems.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar os items';
      }

      throw new APIError(errorMessage);
    }
  }

  public async sortComplementItems(
    companyId: number,
    complementId: number,
    complementItems: Pick<IComplementItem, 'id' | 'order'>[],
  ): Promise<IComplementItem[]> {
    try {
      const sortedComplementItems = await this.httpClient.patch(
        `/companies/${companyId}/complements/${complementId}/items/sort`,
        { complementItems },
      );

      return sortedComplementItems.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar reordenar os items';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteComplementItem(
    companyId: number,
    complementItemId: number,
  ): Promise<void> {
    try {
      await this.httpClient.delete(
        `/companies/${companyId}/items/${complementItemId}`,
      );
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir o item';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new ComplementItemsService();
